<template>	
	
	<div class="Grouping-wrapper col-xs-6 mb-4" v-if="objData">
		<div class="ReSearchMObjSmall">
			<div class="card groupCard pt-2 h-100"
			:class="[{'groupCard-warning':objData.service_status == 'На контроле'}, 
			{'groupCard-danger':objData.service_status == 'В архиве'}, 
			{'groupCard':objData.service_status == 'В работе'}, 
			{'groupCard':objData.service_status == 'Новая'}, 
			{'groupCard':objData.service_status == 'Новая услуга'}, 
			{'groupCard-success':objData.service_status == 'Сделка закрыта'}]">
				
				<div class="groupTopBlock" >
					
					<div class="objectPhoto mb-4">
						<!-- <el-carousel :autoplay="false" arrow="always" type="card" height="200px">
						<el-carousel-item v-for="item in 4" :key="item">
							
							<div class="medium"></div>
						</el-carousel-item>
						</el-carousel> -->
						<!-- <div>
							<img v-if="masObjImages == ''" src="/img/flatsDefault.svg" style="height: 100%;" alt=""> 
						</div> -->
						<span class="statusIcon">
							<span class="text-success ml-2" v-if="objData.service_status == 'Сделка закрыта'"><i class="tim-icons icon-coins mr-2"></i>Сделка закрыта</span>
							<span class="text-danger ml-2" v-if="objData.service_status == 'В архиве'"><i class="tim-icons ics-rate-face-2 mr-2" ></i>Услуга в архиве</span>
							<span class="text-warning ml-2" v-if="objData.service_status == 'На контроле'"><i class="tim-icons ics-rate-face-off mr-2"></i>Услуга на контроле</span>

							<span class="text-primary" v-if="objData.service_status == 'В работе'"><i class="tim-icons ics-rate-face-3 mr-2"></i>Услуга в работе</span>
							<span class="text-primary" v-if="objData.service_status == 'Новая услуга'"><i class="tim-icons ics-rate-face-3 mr-2"></i>Новая услуга</span>
							<span class="text-primary" v-if="objData.service_status == 'Новая'"><i class="tim-icons ics-rate-face-3 mr-2"></i>Новая услуга</span>
						</span>
						<img v-if="objData.photos" :src="`${objData.photos[0]}`" onerror="this.src='/img/flatsDefault.svg'; this.onerror=''" alt="" @click="OpenObject(objData.id)"> 
						<img v-else src="/img/flatsDefault.svg" alt="" @click="OpenObject(objData.id)"> 
					</div>	
					<div class="row align-items-center justify-content-between mx-0 mt-3">
						<div class="d-flex flex-wrap">
							<span class="badge badge-default mr-2" style="font-size: 12px;">{{objData.dealType}}</span>
							<span class="badge badge-default mr-2" style="font-size: 12px;">{{objData.objectType}}</span>
							<span v-if="objData.promo" class="badge badge-primary">промо</span>
							<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="objData.act =='0'">Объект в архиве</span>
							<span class="badge badge-warning mr-2" style="font-size: 12px;" v-if="objData.vilage_mortage">с/х ипотека</span>
							<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="objData.draft && objData.draft!='undefined' && objData.draft ==true">Черновик</span>

							<span class="badge badge-success mr-2" style="font-size: 12px;" v-if="objData._actual!='undefined' && objData._actual==1">Актуально</span>
							<span class="badge badge-info mr-2" style="font-size: 12px; " v-if="objData._actual!='undefined' && objData._actual==0 && objData.export_sites_count=='0'">Снято</span>
						</div>	
						<!-- <div class="bntGroup">
							<button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple">
								<i class="d-inline-block tim-icons icon-book-bookmark"></i>
							</button>
						</div> -->
					</div>			
				</div>

				
					<div class="clientinfo mt-3"> 
							<div class="d-flex flex-wrap mb-2">
								<p class="mr-2 mb-0">Клиент: </p>
								<router-link :to="'/data/clients/id/'+objData.client_id"> посмотреть профиль</router-link>
								<!-- <router-link :to="'/data/clients/id/'+objData.client_id+'?phoneint='+this.phoneintClientContsct.concact_phone_INT"> посмотреть профиль</router-link> -->
							</div>
							<div class="d-flex flex-wrap align-items-center mb-2" v-if="objData.service_agent_id!='undefined' || objData.service_agent_fio!='undefined'">
								<p class="mr-2 mb-0">Ответственный за услугу: </p>
								<div class="d-flex justify-content-between align-items-center">
									<router-link :to="'/data/staff/id/'+objData.service_agent_id"> {{objData.service_agent_fio}}</router-link>
									<!-- <template v-if="getObjects" class="ml-1">
										<el-popover
											placement="left"
											:title="objData.service_agent_fio"
											width="500"
											trigger="click"
											>
											<template slot="reference">
												<base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"><i class="tim-ic ic-eye"></i></base-button>
											</template>
											<template slot="default">
												<div class="col" >
													<ReLeadStaffInfo :objData="getObjects"  />
												</div>
											</template>
											
										</el-popover>
									</template>	 -->
								</div>
							</div>	
							<!-- <p>Согласие на рекламу: <span > № {{  }}</span></p> -->
							<p><re-agrm-info :info="objData" :dates="false"></re-agrm-info></p>

							

						</div>	
				

				<div class="groupBottBlock">
					<div class="row">
						<div class="col baseInfo" v-if="objData.name">
							<p><b>{{objData.name}}</b></p>
						</div>						
					</div>
					<div class="row justify-content-between" v-if="objData.price">
						<p>ID {{objData.id}} </p><p>{{$GVO.number_format(objData.price,0,'.',' ')}} ₽ </p>
						<!-- <p>ID {{objData.id}} </p><p>{{objData.price}} ₽ </p> -->
					</div>
					<p v-if="objData.MapAddress || objData.address" class="objectAddress">
						<span v-if="objData.address && objData.address.text!='undefined'">{{objData.address.text}}, </span>
						<span v-else>{{objData.MapAddress.address.inputText}}, </span>

						<span v-if="objData.MapAddress.flat_num && (objData.objectType == 'Квартиры' || objData.objectType =='Новостройки' ||objData.objectType =='Комната')">номер квартиры</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Дома'">номер дома</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Земля'">номер участка</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Комм.Земля'">номер земли</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Помещения'">номер офиса (помещения)</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Склады'">номер склада</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Гаражи'">номер гаража</span>
						<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Машиноместа'">номер паркинга (машиноместа)</span>


						<span> {{objData.MapAddress.flat_num}}
						<!-- <span v-if="objData.MapAddress.distr_name "> р-н {{objData.MapAddress.distr_name}}, </span> -->
						</span>
					</p>  
					<div class="metro" >						
						<ul class="list-group" v-if="objData.MapAddress">							
							<li v-for="metro in objData.MapAddress.arrMetro" :key="metro.id">
								<div class="metro-row mr-2" v-if="metro.metro_name">
									<div class="d-inline-flex mr-2" v-if="metro.metro_name != ''">
										<i class="tim-ic ic-metro text-primary mr-1"></i>
										<p>{{metro.metro_name}}</p>
									</div> 
									<div class="d-inline-flex align-items-baseline">
										<i v-if="metro.distanceType == 'WALK'" class="metroIc tim-icons icon-user-run text-primary"></i> 
										<i v-if="metro.distanceType == 'TRANSPORT'" class="metroIc tim-icons icon-bus-front-12 text-primary"></i> 
										<p  v-if="metro.distanceToMetro != ''">{{distanceInHours(metro.distanceToMetro)}} ,</p>									
									</div> 
								</div>	
							</li>							
						</ul>						
					</div>
					<div class="object-row objDots" v-if="objData.square && objData.objectType!='Участки' && objData.objectType!='Участок' && objData.objectType!='Земля' && objData.objectType!='Комм.Земля'"><p>S общая</p><span></span><p>{{objData.square}} м<sup>2</sup></p></div>
					<div class="object-row objDots" v-if="objData.square && (objData.objectType=='Участки' || objData.objectType=='Участок' || objData.objectType=='Земля' || objData.objectType=='Комм.Земля')"><p>S общая</p><span></span><p>{{objData.square}} сот</p></div>

					<div class="object-row objDots" v-if="objData.kitchenSquare"><p>S кухни</p><span></span><p>{{objData.kitchenSquare}} м<sup>2</sup></p></div>
					<div class="object-row objDots" v-if="objData.landSquare"><p>S участка</p><span></span><p>{{objData.landSquare}} сот</p></div>

					<!-- <div class="object-row objDots" v-if="objData.Toilet"><p>Туалет</p><span></span><p>{{objData.Toilet}}</p></div> -->
					<!-- <div class="object-row objDots" ><p>Floor</p><span></span><p>{{objData.floor}}</p></div>
					<div class="object-row objDots" ><p>Floors</p><span></span><p>{{objData.floors}}</p></div> -->

					<!-- <div class="d-flex justify-content-center">
						<button class="btn btn-simple btn-success">Подробнее</button>
					</div> -->

					
									
				</div>

				
				<div class="row align-items-baseline justify-content-between mx-0 mt-auto">
					<div class="zipal-errors mb-3 " v-if="objData.zipal_error!='' && objData.zipal_error!=null">
						<h4 class="text-danger"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Исправьте ошибки объекта, полученные при отправке</h4>
						<div class="zipal-error-text "><p >{{ objData.zipal_error }}</p></div>
					</div>
					<span class="badge badge-success mr-2" style="font-size: 12px;" v-if="objData.moderation_status_id != '' && objData.moderation_status_id == 2">Объект принят</span>
					<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="objData.moderation_status_id != '' && objData.moderation_status_id == 3">Объект отклонен </span>
					<span class="badge badge-default mr-2" style="font-size: 12px;" v-if="objData.moderation_status_id == 1">Объект не проверен </span>
					<!-- <div class="bntGroup" v-if="this.$GVO.my_profile.code == 10420">
						<el-tooltip content="Добавить в презентацию" placement="bottom">
							<button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple" @click="AddToPres()">
								<i class="d-inline-block tim-icons icon-book-bookmark"></i>
							</button>
						</el-tooltip>
						<el-tooltip content="Перейти в презентацию" placement="bottom">
							<button type="button" class="btn my-0 btn-icon btn-fab btn-info btn-simple" @click="getPres()">
								<i class="d-inline-block tim-icons icon-book-bookmark"></i>
							</button>
						</el-tooltip>
					</div> -->
				</div>
				
			</div>
		
		</div>
	</div>
	
</template>

<script>
import { Carousel, CarouselItem, Tooltip, Button, Popover } from "element-ui";	
import ReAgrmInfo from 'src/our_components/ReAgrmInfo.vue';


export default {
	name: 'ReSearchMObjSmall',
	components: {  
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,   
		[Button.name]: Button,
		[Tooltip.name]: Tooltip,	
		[Popover.name]: Popover,
		ReAgrmInfo,
	},
	props: {
		objData: Object,

		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
	},
	data () {
		return {
			ver: 1,
			phoneintClientContsct: {},
			linkText: '',
			// objCatData: {
			// 	objectType:{value:'', catalog:'ObjectType',options:[], value_default: ''},
			// 	dealType:{value:'', catalog:'DealType', options:[], value_default: ''},

			// }
			
		}
	},
	computed: {
		
	},
	methods: {
		OpenObject(id){
				this.objGetParams = this.$GVO.GetAllGet();
				let strConstGetParams = '';
				//let masParams = [];
				if(typeof this.objGetParams.task_id != 'undefined' && typeof this.objGetParams.taskend_id != 'undefined' && typeof this.objGetParams.client_id != 'undefined'){
					strConstGetParams = `?task_id=${this.objGetParams.task_id}&taskend_id=${this.objGetParams.taskend_id}&client_id=${this.objGetParams.client_id}`;
				}

				// location.href = '/data/module/mo/object/'+id+strConstGetParams;
				this.$router.push({path:'/data/module/mo/object/'+id+strConstGetParams});

				// console.log('Нажали на фотку в карточке рекламного объекьа');
			},
		distanceInHours(distanceToMetro){
			let hour = 60;
			let distanceToMetroMin;
			let distanceToMetroHours;
			let strDistanceToMetro = '';
			let min = ' мин';
			if(distanceToMetro > hour){
				distanceToMetroHours = Math.floor(distanceToMetro / hour);
				distanceToMetroMin = distanceToMetro % hour;		
				if(distanceToMetroMin == 0){min = ''; distanceToMetroMin = '';}
				strDistanceToMetro = distanceToMetroHours + ' ч ' + distanceToMetroMin + min;
			} else {
				distanceToMetroMin = distanceToMetro;
				strDistanceToMetro = distanceToMetro + ' мин';
			}
			// console.log(distanceToMetroHours + " ч " + minutes + " мин");
			return strDistanceToMetro;
		},
		// AddToPres(){
		// 		const objGetParams = this.$GVO.GetAllGet();
		// 		if(!this.$GVO.isEmpty(objGetParams)){
		// 			this.$GVO.ApiCall('INSUPD_OBJ_TO_PRES',{
		// 				obj:'presentations',
		// 				flt:{
		// 					client_id:objGetParams.client_id,
		// 					task_id:objGetParams.task_id,
		// 					taskend_id:objGetParams.taskend_id
		// 				},iData:{
		// 					app_id:this.objData.id,
		// 					type: 3
		// 				}
		// 			})
		// 			.then((objApi) => {
		// 				if(objApi.success === true){
		// 					this.objData.inPresentation = 1;
		// 				}
		// 			}).catch(errorObjApi => {this.ApiData = []; console.log(errorObjApi);});
		// 		}else{
		// 			alert('Нет параметров задачи и клиента');
		// 		}
		// 	},
		// getPres(){
		// 	let objItogGetParams = this.$GVO.GetAllGet();
		// 		this.$GVO.ApiCall('CREATE_PRESENTATION',{obj:'presentations',flt:{'task_id':objItogGetParams.task_id,'taskend_id':objItogGetParams.taskend_id,'client_id':objItogGetParams.client_id}, iData:{}})
		// 		.then((objApi) => {
		// 			if(objApi.success === true){
		// 				this.linkText = objApi.data.link;
		// 				console.log(this.linkText);
		// 			}
		// 		}).catch(errorObjApi => {console.log(errorObjApi);});
		// },
		// getClientContacts(objData){
		// 	// const client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
		// 	//console.log(this.objData);
		// 	this.$GVO.ApiCall('GET_CONTAKCS',{obj:'client',flt:{id:this.objData.client_id}})
		// 	.then((objApi) => {
		// 		let client_contacts = [];
		// 		// this.history_total = 0;
		// 		if(objApi.success === true){
		// 			if(objApi.data.length > 0){
		// 				client_contacts = objApi.data;
		// 				// this.client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
		// 				for (let i = 0; i <client_contacts.length; i++) {
		// 					if(client_contacts[i].contact_type == '1') {
		// 						this.phoneintClientContsct =client_contacts[i];
		// 						// this.whatsapp_contact = client_contacts[i];
		// 						// console.log(this.whatsapp_contact);
		// 					}
		// 				}
		// 			}
		// 		}
		// 	}).catch(errorObjApi => console.log(errorObjApi));
		// },
		// SetCats(strCat){
		// 	for (const key in this.objCatData) {
		// 		if (this.objCatData.hasOwnProperty(key)) {
		// 			if(typeof this.objCatData[key].catalog != 'undefined' && this.objCatData[key].catalog == strCat){
		// 				this.objCatData[key].options = this.$GVO.getCatToSelect(this.objCatData[key].catalog);
		// 			}
		// 		}
		// 	}
		// },
		

	},
	mounted() {
		if(typeof this.objData != 'undefined'){
			// this.getClientContacts();
			// console.log(this.objData.id, ' documentationUrl: ', this.objData.documentationUrl);
		}
		// this.$GVO.ApiCall('cat.GET_ZIPAL_CAT',{params:['ObjectType','DealType']})
		// .then((objApi) => {
		// 	//console.log(objApi);
		// 	if(objApi.success === true){
		// 		for (const key in objApi.data) {
		// 			if (Object.hasOwnProperty.call(objApi.data, key)) {
		// 				this.$GVO.cats[key] = [];
		// 				for (let i = 0; i < objApi.data[key].length; i++) {
		// 					this.$GVO.cats[key].push({'id':objApi.data[key][i].value,'name':objApi.data[key][i].label});
		// 				}
		// 				// this.SetCats(key);
		// 			}
		// 		}
				
		// 	}
		// }).catch(errorObjApi => {console.log(errorObjApi);});
	},
}
</script>

<style scoped>
.ReSearchMObjSmall {width: 300px;}
.Grouping-wrapper  {display: flex; flex-wrap: wrap; margin-right: 15px;}
.ReSearchMObjSmall {padding: 0px 5px 10px 5px;}
.ReSearchMObjSmall >>> .row {margin: 0px 0px 5px 0px;}
.ReSearchMObjSmall:not(:last-child) {margin-right: 15px;}
.groupCard {border: 1px solid #9e77f3; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; padding: 10px 15px; height: -webkit-fill-available;}
.groupCard-warning {border: 1px solid #ff8d72; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; padding: 10px 15px; height: -webkit-fill-available;}
.groupCard-success {border: 1px solid #00bf9a; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; padding: 10px 15px; height: -webkit-fill-available;}
.groupCard-danger {border: 1px solid #f84e54; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; padding: 10px 15px; height: -webkit-fill-available;}
.groupBottBlock {padding:0px 10px 0px 0px;}
.groupTopBlock {border-bottom: 1px solid #01b0e0; padding: 20px 0px 0px 0px; position: relative;}
.groupBottBlock {padding-top: 10px;}
.baseInfo {padding: 0px;}
.objectPhoto {display: flex; width: 100%; height: 200px; cursor: pointer;}
.objectPhoto img {width: 100%; height: 100%; margin: 0 auto; object-fit: cover;}
.onFloor {text-align: center; cursor: pointer; margin-bottom: 8px; padding-top: 5px;}
.onFloor p {color: #01b0e0;}
.groupFlats {z-index: 2; position: absolute; top: 20px; left: 0px; background: rgb(39, 41, 61, 0.9); padding: 5px 5px 10px 8px; width: 100%;}
.white-content .card:not(.card-white) .groupFlats {background: rgb(255, 255, 255, 0.95);}
.groupFlats-show {display: block;} 
.groupFlats-hide {display: none;} 
.groupfloor p:not(:last-child) {margin-right: 10px;}
.groupfloor {display: flex; flex-wrap: wrap; border-bottom: 1px solid rgb(1, 176, 224, 0.4);;}
.groupfloor p {color: unset;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metro-row  {display: flex; flex-wrap: wrap;}
.ReSearchMObjSmall >>> .list-group  {list-style: none;}

.objectPass {display: flex; justify-content: flex-start; flex-wrap: wrap;}
.objectPass  p:not(:first-child) {margin-left: 10px; padding-left: 5px;position: relative;}
.objectPass p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: -3px;
	top: 40%;
} 
.objectPass .blue-dot {margin-right: 7px; padding-right: 12px; position: relative;}
.objectPass .blue-dot:not(:last-child)::after {
	content: '';
	position: absolute;
	margin-left: 7px;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #01b0e0;
	top: 30%;
	right: 2px;
}
.objectPass-row {display: flex; flex-wrap: wrap;}
.objectDev {display: flex; justify-content: space-between; padding-right: 0px;}
.ReSearchMObjSmall .money, .ReSearchMObjSmall .floor {margin-bottom: 2px;}
.ReSearchMObjSmall .object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.ReSearchMObjSmall .object-row p:first-child {/*min-width: 100px;*/ margin-right: 10px;}
.objectPhoto img {border: 1px solid transparent;}
.objectPhoto img:hover {cursor: pointer; box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.5); border: 1px solid #01b0e0;}
.ReSearchMObjSmall >>> .zipal-errors {margin-bottom: 15px; border: 1px dashed #F84E54; border-radius: 6px; padding: 10px; grid-gap: 10px; max-width: 260px; max-height: 270px; overflow: hidden;}
.ReSearchMObjSmall >>> .zipal-error-text {white-space:pre-wrap; line-height: 1; /*text-overflow: ellipsis; white-space: nowrap;*/}
/* .ReSearchMObjSmall >>> .zipal-error-text p {display: initial;} */
.ReSearchMObjSmall >>>  .clientinfo {    border: 1px dashed #01b0e0; padding: 10px 10px 5px 10px; border-radius: 6px;}
.statusIcon {position: absolute; top: 0; left: 0; display: inline-flex; align-items: center;}

/*===media===============================*/
@media (max-width: 768px) {	
	.ReSearchMObjSmall {width: 100%; margin-bottom: 15px;}
	.Grouping-wrapper {flex-direction: column; width: 100%; margin-right: 0px;}
	.groupfloor {font-size: 12px;}
	.groupBottBlock {padding: 0px 10px 0px 10px;}
}


</style>
